import { render, staticRenderFns } from "./CopyId.vue?vue&type=template&id=38bc08a2&scoped=true&"
import script from "./CopyId.vue?vue&type=script&lang=js&"
export * from "./CopyId.vue?vue&type=script&lang=js&"
import style0 from "./CopyId.vue?vue&type=style&index=0&id=38bc08a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bc08a2",
  null
  
)

export default component.exports